import React from 'react';

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const FeaturedCompaniesSection = (props) => {
  const { data, companyType, parentPage, history } = props;
  
  return (
    <section className="volunteers-team school-sec-7">
      {
        data && data.length ?
          <span>
            <h5 className="text-grn text-center mb-0">Help them for hapiness!</h5>
            <h3 className="main-heading mb-4 text-center">Featured {companyType}</h3>
            <div className="container mt-3">
              <OwlCarousel className="owl-carousel owl-theme campaignTrendingCards" margin={28} dots={true} responsive={{ 0: { items: 3 } }} nav={false}>
                {
                  data.map(({ company_name, cover_image, id }, index) => {
                    let imageCover = '/images/1.PNG';
                    if (cover_image) {
                      imageCover = `${process.env.REACT_APP_BACKEND_BASE_URL}/${cover_image}`;
                    }
                    return (
                      <div key={index} className="card border-0 text-center">
                        <a href={`/${companyType.toLowerCase()}-details/${id}`}>
                          <img style={{ height: '219px' }} src={imageCover} className="img-fluid" alt="" />
                          <p className="mb-0 mt-3">Recent Added</p>
                          <h4>{company_name}</h4>
                        </a>
                      </div>
                    );
                  })
                }
              </OwlCarousel>
              {
                parentPage === 'industryMain' ?
                <div className="mt-4 text-center">
                  <button onClick={() => history.push(`${companyType}-listing`)} type="button" className="btn btn-outline-dark">VIEW ALL</button>
                </div> : ''
              }
            </div>
          </span> : ''
      }
    </section>
  );
};

export default FeaturedCompaniesSection;